import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class StopLineupsGeneration extends Component {
    onClick() {
        this.props.dispatch(Action.set('StatusOfLineupsIsFilled', true));
    }

    render() {
        return (
            <span className="btn" onClick={(e) => ::this.onClick()}>
                Abort
            </span>
        );
    }
}

export default connect(() => ({}))(StopLineupsGeneration);
